module.exports = __webpack_public_path__ + "img/image_news_lalamee.7f2989c4.png";